export enum ThemeColors {
  colorPrimary = 'colorPrimary',
  colorSuccess = 'colorSuccess',
  colorWarning = 'colorWarning',
  colorError = 'colorError',
  colorInfo = 'colorInfo',
  colorLink = 'colorLink',
  colorAttention = 'colorAttention',
  colorActive = 'colorActive',
  colorReverse = 'colorReverse',
  colorErrorLight = 'colorErrorLight',
  colorSecondary = 'colorSecondary',
  colorDescription = 'colorDescription',
  colorBrand = 'colorBrand',
}
